<template>
  <div>

    <div class="stepsdemo-content">
      <div class="card card-theme">
        <h3 class="card-title">
          Staff
        </h3>
        <h6 class="card-subtitle">
          Please add client's staff
        </h6>
        <div class="p-grid p-nogutter p-justify-between">
          <Button label="Back" @click="prevPage()" icon="pi pi-angle-left"/>
          <Button label="Save"
                  @click="handleSubmit()"
                  icon="pi pi-angle-right"
                  iconPos="right"
                  v-if="user_accesses && userService && userService.hasAccess(user_accesses, ['admin', 'edit_client', 'add_client'])"
          />
        </div>
      </div>
    </div>

    <Panel class="capital"
           v-for="(staff, index) of staffs"
           :header="'#' + (index + 1) + '. ' + (staff.username ? staff.username : 'Add staff\'s info')"
           :key="staff.code"
           :toggleable=true
           :collapsed=checkCollapsed()
    >
      <template #icons>
        <button v-if="staffs.length > 1 && (user_accesses && userService && userService.hasAccess(user_accesses, ['admin', 'edit_client', 'add_client']))"
                class="p-panel-header-icon pi pi-trash"
                @click="staffRemoveConfirm(staff.code)">
        </button>
      </template>
      <div class="p-grid nested-grid">
        <div class="p-col-12 p-lg-5">
          <h3 class="card-title">
            Profile Info
          </h3>

          <div class="p-grid">
            <div class="p-col-12">
              <span class="form-group">
                <label for="username">Username</label>
                <InputText type="text" v-model="staff.username" class="form-control" :class="{ 'is-invalid': submitted && $v.staffs.$each.$iter[index].username.$error }"/>
                <div v-if="submitted && !$v.staffs.$each.$iter[index].username.required" class="invalid-feedback">Username is required</div>
                <div v-if="submitted && !$v.staffs.$each.$iter[index].username.minLength" class="invalid-feedback">Username must have at least {{$v.staffs.$each.$iter[index].username.$params.minLength.min}} characters</div>
              </span>
            </div>
            <div class="p-col-12">
              <span class="form-group">
                <label for="first_name">First Name</label>
                <InputText type="text" v-model="staff.first_name" class="form-control" :class="{ 'is-invalid': submitted && $v.staffs.$each.$iter[index].first_name.$error }"/>
                <div v-if="submitted && !$v.staffs.$each.$iter[index].first_name.required" class="invalid-feedback">First name is required</div>
                <div v-if="submitted && !$v.staffs.$each.$iter[index].first_name.minLength" class="invalid-feedback">First name must have at least {{$v.staffs.$each.$iter[index].first_name.$params.minLength.min}} letters</div>
              </span>
            </div>
            <div class="p-col-12">
              <span class="form-group">
                <label for="last_name">Last Name</label>
                <InputText type="text" v-model="staff.last_name" class="form-control" :class="{ 'is-invalid': submitted && $v.staffs.$each.$iter[index].last_name.$error }"/>
                <div v-if="submitted && !$v.staffs.$each.$iter[index].last_name.required" class="invalid-feedback">Last name is required</div>
                <div v-if="submitted && !$v.staffs.$each.$iter[index].last_name.minLength" class="invalid-feedback">Last name must have at least {{$v.staffs.$each.$iter[index].last_name.$params.minLength.min}} letters</div>
              </span>
            </div>
            <div class="p-col-12">
                <span class="p-field">
                  <label for="roles">Roles</label>
                  <MultiSelect class="card-input" id="roles" v-model="staff.roles" :options="role_list"
                               optionLabel="name" placeholder="Select Roles"/>
                  <!--                  <InputText class="card-input" id="roles" type="text" v-model="staff.roles"/>-->
                </span>
            </div>
            <div class="p-col-12">
              <label>Images</label>
              <image-uploader
                      :images="staff.images"
                      :code="staff.code"
                      maxImage=1
                      @new-image="onNewImage"
                      @edit-image="onEditImage"
                      @remove-image="onRemoveImage"
              ></image-uploader>
            </div>

          </div>

        </div>

        <div class="p-col-12 p-lg-1"></div>

        <div class="p-col-12 p-lg-5">
          <h3 class="card-title">
            Contact Info
          </h3>

          <div class="p-col-12">
            <div class="form-group">
              <label for="email">Email</label>
              <InputText type="text" v-model="staff.email" class="form-control" :class="{ 'is-invalid': submitted && $v.staffs.$each.$iter[index].email.$error }" />
              <div v-if="submitted && !$v.staffs.$each.$iter[index].email.required" class="invalid-feedback">Email is required</div>
              <div v-if="submitted && !$v.staffs.$each.$iter[index].email.email" class="invalid-feedback">Email is not valid</div>
            </div>
          </div>

          <div class="p-col-12">
            <div class="form-group">
              <label for="mobile">Mobile</label>
              <InputText type="text" v-model="staff.mobile" class="form-control" :class="{ 'is-invalid': submitted && $v.staffs.$each.$iter[index].mobile.$error }" />
              <div v-if="submitted && !$v.staffs.$each.$iter[index].mobile.numeric" class="invalid-feedback">Mobile number must be numeric</div>
              <div v-if="submitted && !$v.staffs.$each.$iter[index].mobile.minLength" class="invalid-feedback">Mobile number must have at least {{$v.staffs.$each.$iter[index].mobile.$params.minLength.min}} digits</div>
            </div>
          </div>
          <div class="p-col-12">
            <span class="p-field">
              <label for="landline">Landline</label>
              <InputText class="card-input" id="landline" type="text" v-model="staff.landline"/>
            </span>
          </div>

        </div>
      </div>
    </Panel>

    <br>

    <Button icon="pi pi-plus"
            class="p-button-success p-mr-2"
            @click="newStaff"
            v-if="user_accesses && userService && userService.hasAccess(user_accesses, ['admin', 'edit_client', 'add_client'])"
    />

    <Dialog :visible.sync="deleteStaffDialog" :style="{width: '450px'}" header="Confirm" :modal="true">
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem"/>
        <span v-if="staff.first_name && staff.last_name">Do you want to remove {{staff.first_name}} {{staff.last_name}}?</span>
        <span v-else>Do you want to remove this Staff?</span>
      </div>
      <template #footer>
        <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteStaffDialog = false"/>
        <Button label="Yes"
                icon="pi pi-check"
                class="p-button-text"
                @click="removeStaff"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
  import ImageUploader from "../ImageUploader";
  import UserService from '../../services/UserService';
  import { required, minLength, email, numeric } from 'vuelidate/lib/validators'

  export default {
    components: {ImageUploader},
    data() {
      return {
        staffs: [],
        staff: {},
        role_list: [
          {name: 'Manager', code: 'client_manager'},
          {name: 'Reporter', code: 'client_reporter'}
        ],
        deleteStaffDialog: false,
        deleteImageDialog: false,
        user_accesses: this.$store.state.accesses,
        userService: null,
        submitted: false
      }
    },
    validations: {
      staffs: {
        $each: {
          username: {
            required,
            minLength: minLength(6)
          },
          first_name: {
            required,
            minLength: minLength(2)
          },
          last_name: {
            required,
            minLength: minLength(2)
          },
          email: {
            required,
            email
          },
          mobile: {
            minLength: minLength(10),
            numeric 
          },
        }
      }
    },
    created() {
      this.userService = new UserService();
    },
    methods: {
      handleSubmit() {
        this.submitted = true;

        // stop here if form is invalid
        this.$v.$touch();
        if (this.$v.$invalid) {
          this.$toast.add({
            severity: 'warn',
            summary: 'Validation failed!',
            detail: 'You can proceed after all marked fields are rectified',
            life: 5000
          });
          return;
        }

        this.$emit('complete', {
          formData: {
            staffs: this.staffs,
            step: 'staff_info'
          },
          pageIndex: 2
        });

      },
      prevPage() {
        this.$emit('prevPage', {pageIndex: 2});
      },
      checkCollapsed() {
        return (this.staffs && this.staffs[0].id !== '')
      },
      staffRemoveConfirm(code) {
        let index = this.staffs.findIndex(item => item.code === code);
        this.staff = this.staffs[index];
        this.deleteStaffDialog = true;
      },
      removeStaff() {
        this.staffs = this.staffs.filter(item => item.code !== this.staff.code);
        this.staff = {};
        this.deleteStaffDialog = false;
      },
      newStaff(staff) {
        this.staffs.push(
            {
              code: this.uniqueID(),
              id: staff ? staff.id : '',
              username: staff ? staff.username : '',
              first_name: staff ? staff.first_name : '',
              last_name: staff ? staff.last_name : '',
              email: staff ? staff.email : '',
              mobile: staff ? staff.mobile : '',
              landline: staff ? staff.landline : '',
              roles: staff && staff.roles && staff.roles.length > 0 ? this.role_list.filter(item => staff.roles.map(item => item.name).includes(item.code)) : [{name: 'Reporter', code: 'client_reporter'}],
              images: staff && staff.images ? staff.images : [],
              image: {},
            }
        )
      },
      uniqueID() {
        return Math.random().toString(36).slice(2);
      },
      onNewImage(code, image) {
        let index = this.staffs.findIndex(item => item.code === code);
        this.staffs[index].images.push(image)
      },
      onEditImage(code, img_index, fileList) {
        let index = this.staffs.findIndex(item => item.code === code);
        this.staffs[index].images[img_index] = fileList[img_index]
      },
      onRemoveImage(code, img_index) {
        let index = this.staffs.findIndex(item => item.code === code);
        this.staffs[index].images.splice(img_index, 1);
      }
    },
    mounted() {
      let client_info = localStorage.getItem("client_info") ? JSON.parse(localStorage.getItem("client_info")) : null;
      if (client_info && client_info.users && client_info.users.length > 0) {
        client_info.users.map(staff => this.newStaff(staff));
      } else {
        this.newStaff();
      }
    }
  }
</script>

<style scoped>
  .card-subtitle {
    margin: 0;
    margin-bottom: 3em;
  }

  .card-title {
    margin-bottom: 0.5em;
    font-weight: bold;
  }

  .card-input {
    width: 100%;
    margin-bottom: 1rem;
  }

  .capital {
    text-transform: capitalize;
  }
</style>